<script lang="ts">
import { defineComponent, ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { enrollPasskey } from '@/services/auth/enroll-passkey-my-account'

const { useState: useLoginDomainStoreState } = createNamespacedHelpers('LoginDomain')

export default defineComponent({

  name: 'PasskeyEnrollmentPage2',

  setup() {

    const { tenant } = useLoginDomainStoreState(['tenant'])

    const loading = ref(false)
    const error = ref('')
    const success = ref(false)

    const initEnrollment = async () => {

      error.value = ''
      success.value = false
      loading.value = true

      try {
        await enrollPasskey(tenant.value)
        success.value = true
      } catch (e) {
        error.value = (e as Error)?.message || 'Passkey enrolment failed'
        // eslint-disable-next-line no-console
        console.error('[passkey-poc] enrolment failed', e)
      } finally {
        loading.value = false
      }

    }

    return {
      loading,
      error,
      success,
      initEnrollment,
    }

  },

})

</script>

<template>
  <div class="container">
    <sm-button
      :loading="loading"
      @click="initEnrollment"
    >
      Enroll passkey
    </sm-button>

    <p
      v-if="success"
      class="message message--success"
    >
      Passkey enrolled ✅
    </p>

    <p
      v-if="error"
      class="message message--error"
    >
      {{ error }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.container {
  @apply flex flex-col gap-4 justify-center items-center min-h-screen;
}

.message {
  &--success {
    @apply text-green-600;
  }

  &--error {
    @apply text-red-600;
  }
}
</style>
